(() => {
	angular
		.module('main')
		.directive('addWorkflowTaskModal', addWorkflowTaskModal);

	addWorkflowTaskModal.$inject = ['$location', 'workflowService'];

	function addWorkflowTaskModal($location, workflowService) {
		return {
			restrict: 'E',
			scope: {},
			template: `
                        <div id="addWorkflowTaskModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header pt-pb-15">
                                       <btn-close></btn-close>
                                        <h3 class="modal-title f-s-20">Add new workflow task</h3>
                                    </div>
                                    <div class="modal-body add-new-modal add-new-list" style="padding-bottom: 5px!important; padding-top: 30px!important">
                                        <h2 class="add-new-tip">I want to add a new...</h2>
                                        
                                        <btn-add-new-job-element add="showAddTodoModal()"
                                                                 icon="fi-checkbox fi-job"
                                                                 title="to-do"
                                                                 description="Add a to-do task which you check off when you get it done."
                                        ></btn-add-new-job-element>
                    
                                        <btn-add-new-job-element add="showAddAutomationModal()"
                                                                 icon="fi-automation fi-job"
                                                                 title="automation"
                                                                 description="Add a task that automatically sends emails, questionnaires and contracts."
                                        ></btn-add-new-job-element>
                                        
                                        <btn-add-new-job-element add="showAddExtraShootModal()"
                                                                 icon="fi fi-camera-cross fi-job mr-20"
                                                                 title="extra shoot"
                                                                 description="Add an additional shoot which appears in your workflow and calendar."
                                        ></btn-add-new-job-element>
                                        
                                         <btn-add-new-job-element add="showAddAppointmentModal()"
                                                                 icon="fi fi-call fi-job mr-20"
                                                                 title="appointment"
                                                                 description="Add an appointment which appears in your workflow and calendar."
                                        ></btn-add-new-job-element>
                                        
                                    </div>
                                </div>
                            </div>
       
                        </div>
                 `,
			replace: true,
			transclude: true,
			link(scope) {
				scope.showAddTodoModal = () => {
					const newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							$('#addTodoModal').modal('show');
							$(this).off('hidden.bs.modal');
						});
				};
				scope.showAddAutomationModal = () => {
					const newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							$('#addAutomationModal').modal('show');
							$(this).off('hidden.bs.modal');
						});
				};

				scope.showAddExtraShootModal = () => {
					const newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							const isSettingsPage = $location
								.path()
								.includes('settings/workflows/');
							const modalToShow = isSettingsPage
								? '#extraShootWithoutScheduleModal'
								: '#extraShootModal';
							$(modalToShow).modal('show');
							$(this).off('hidden.bs.modal');
						});
				};

				scope.showAddAppointmentModal = () => {
					const newTask = workflowService.addEmptyTask();
					workflowService.setTaskInfo(newTask);
					$('#addWorkflowTaskModal')
						.modal('hide')
						.on('hidden.bs.modal', function() {
							const isSettingsPage = $location
								.path()
								.includes('settings/workflows/');
							const modalToShow = isSettingsPage
								? '#appointmentWithoutScheduleModal'
								: '#appointment';
							$(modalToShow).modal('show');
							$(this).off('hidden.bs.modal');
						});
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/Modals/addWorkflowTaskModal.js